<template>
  <DropdownMenuPortal>
    <DropdownMenuContent
      :class="[
        cn(
          'z-50 min-w-[10rem] overflow-hidden rounded bg-neutral-900 p-1 text-neutral-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          props.class
        ),
      ]"
      v-bind="forwarded"
    >
      <slot />
    </DropdownMenuContent>
  </DropdownMenuPortal>
</template>

<script setup>
import {
  DropdownMenuContent,
  DropdownMenuPortal,
  useForwardPropsEmits,
} from 'radix-vue';
import { cn } from '../../utils.js';

const props = defineProps({
  class: {
    type: String,
    default: '',
  },
  sideOffset: {
    type: Number,
    default: 4,
  },
  align: {
    type: String,
    default: 'start', // start | center | end
  },
  alignOffset: {
    type: Number,
    default: 0,
  },
});
const emits = defineEmits([
  'escapeKeyDown',
  'pointerDownOutside',
  'focusOutside',
  'interactOutside',
  'closeAutoFocus',
]);

const forwarded = useForwardPropsEmits(props, emits);
</script>
